import React from 'react';
import Page from "../Components/Page";
import OriginalSongCompetitionScheduleContainer from "../containers/OriginalSongCompetitionScheduleContainer";

const OriginalSongCompetitionSchedulePage = () => {
    return (
        <Page>
            <OriginalSongCompetitionScheduleContainer/>
        </Page>
    );
};

export default OriginalSongCompetitionSchedulePage;